<template>
  <v-slide-y-reverse-transition>
    <section v-if="active" class="alert">
      <v-alert
        v-for="msg in messages"
        :key="msg.id"
        :dismissible="msg.dismissible"
        outlined
        :icon="msg.icon ? `mdi-${msg.icon}`: null"
        transition="slide-y-reverse"
        :style="{ 'background-color': '#fff !important' }"
        :type="msg.type"
        @input="dismiss(msg.id)"
      >
        <strong v-html="msg.content"> </strong>
      </v-alert>
    </section>
  </v-slide-y-reverse-transition>
</template>

<script lang="ts">
import { Msg } from "@/types";
import Vue from "vue";

export default Vue.extend({
  name: "MessageComp",

  data() {
    return {};
  },
  methods: {
    dismiss(id: string) {
      return this.$store.commit("rmMsg", id);
    },
  },
  computed: {
    active(): boolean {
      return this.$store.getters.getMessagesActive;
    },
    messages(): Msg[] {
      return this.$store.getters.getMessages;
    },
  },
});
</script>
<style>
.alert {
  position: absolute !important;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 90%;
  z-index: 9999;
}
</style>
